<template>
	<div>
		<!-- Distributors -->
		<DistributorMap />
		<AttachmentSection :files="files" />
		<InformationSection :sections="information" />

		<!-- Services -->
		<ServiceTabs :items="services" title="Distributor services" />
	</div>
</template>

<script>
import ContentService from '@/services/ContentService'
import ServiceTabs from '@/components/n-collections/ServiceTabs'

import InformationSection from '@/components/base/InformationSection'
import AttachmentSection from '@/components/base/AttachmentSection'

import DistributorMap from '@/components/DistributorMap'

export default {
	name: 'Distributors',

	components: {
		InformationSection,
		AttachmentSection,
		DistributorMap,
		ServiceTabs
	},

	metaInfo: {
    title: 'Distributors'
  },

	data() {
		return {
			services: [],
			distributors: [],
			information: [],
			files: [],
		}
	},

	async created() {
		const {
			services,
			files,
			becomeDistributor,
			distributorInfo
		} = await ContentService.get('distributors')
		
		
		this.services = services
		this.files = files
		this.information.push({title: 'Mission and Availability', text: distributorInfo})
		this.information.push({title: 'How to become a PRIMAR Distributor', text: becomeDistributor})
	},
}
</script>